<template>
  <BaseDialog
    v-model="showDialog"
    :title="title"
    dialogIcon="mdi-information"
    @action="close"
    @close="close"
  >
    <template v-slot>
      <v-text-field v-model="documentVersion" filled label="Versjon" readonly>
      </v-text-field>
      <v-text-field
        v-bind:value="documentVersionDate"
        filled
        label="Versjon (dato/tid)"
        readonly
      >
      </v-text-field>
      <v-text-field
        v-model="documentVersionAuthor"
        filled
        label="Versjon (forfatter)"
        readonly
      >
      </v-text-field>
      <v-textarea
        v-model="documentVersionComment"
        filled
        label="Versjon (kommentar)"
        readonly
      ></v-textarea>
    </template>
  </BaseDialog>
</template>

<script lang="ts">
import Vue from "vue";
import BaseDialog from "@/components/shared/dialog/BaseDialog.vue";
import moment from "moment";

export default Vue.extend({
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    title: {
      type: String,
      default: "",
    },
    document: {
      required: true,
    },
  },
  methods: {
    close() {
      this.$emit("close");
      this.showDialog = false;
    },
  },

  computed: {
    showDialog: {
      get(): boolean {
        return this.value;
      },
      set(value: boolean) {
        this.$emit("input", value);
      },
    },
    documentVersion: {
      get(): number | null {
        return this.document != null ? (this.document as any).version : null;
      },
    },
    documentVersionDate: {
      get(): string | null {
        return this.document != null
          ? moment((this.document as any).dateTime).format("DD.MM.YY HH:mm")
          : null;
      },
    },
    documentVersionAuthor: {
      get(): string {
        return this.document != null ? (this.document as any).author : "";
      },
    },
    documentVersionComment: {
      get(): string {
        return this.document != null
          ? (this.document as any).versionComment
          : "";
      },
    },
  },
  components: {
    BaseDialog,
  },
});
</script>
